import axios from "axios";

const TOKEN_KEY = "OCM_ACCESS_TOKEN";
export const API_BASE_URL = "https://api.velorates.org";

const AxiosClient = axios.create({
    baseURL: API_BASE_URL,
});

AxiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    config.headers = config.headers || {};
    const requestUrl = new URL(config.url || "", API_BASE_URL);
    const isApiRequest = requestUrl.origin === new URL(API_BASE_URL).origin;
    if (token && isApiRequest) config.headers.Authorization = `Bearer ${token}`;
    else delete config.headers.Authorization;

    const removeTenantId = (value) => {
        if (!value || typeof value !== "object") return value;
        if (typeof FormData !== "undefined" && value instanceof FormData) {
            const sanitized = new FormData();
            value.forEach((entry, key) => {
                if (key.toLowerCase() !== "tenant_id") sanitized.append(key, entry);
            });
            return sanitized;
        }
        if (value instanceof Date || (typeof Blob !== "undefined" && value instanceof Blob)) return value;
        if (Array.isArray(value)) return value.map(removeTenantId);
        if (value instanceof URLSearchParams) {
            const sanitized = new URLSearchParams(value);
            sanitized.delete("tenant_id");
            return sanitized;
        }
        return Object.fromEntries(Object.entries(value)
            .filter(([key]) => key.toLowerCase() !== "tenant_id")
            .map(([key, entry]) => [key, removeTenantId(entry)]));
    };

    if (config.params) config.params = removeTenantId({ ...config.params });
    if (config.data && typeof config.data === "object") config.data = removeTenantId(config.data);
    return config;
});

AxiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const requestUrl = error.config?.url ? new URL(error.config.url, API_BASE_URL) : null;
        const isApiRequest = requestUrl?.origin === new URL(API_BASE_URL).origin;
        if (error.response?.status === 401 && isApiRequest) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem("OCM_USER");
            localStorage.removeItem("OCM_TENANT");
            window.dispatchEvent(new Event("ocm:unauthorized"));
        }
        return Promise.reject(error);
    }
);

export default AxiosClient;
